/**
 * Root saga
 */
import { spawn } from 'redux-saga/effects';

import { authSagas } from './slices/authSaga';
import { modulesSagas } from '../pages/Modules/modulesSaga';
import { programsSagas } from '../pages/Programs/programsSaga';
import { resourcesSagas } from '../pages/Resources/resourcesSaga';
import { microPracticesSagas } from '../pages/MicroPractices/microPracticesSaga';
import { playlistsSagas } from '../pages/Playlists/playlistsSaga';
import { usersSagas } from '../pages/Users/usersSaga';
import { settingsSagas } from './slices/settingsSaga';
import { programCategoriesSagas } from '../pages/Categories/programCategoriesSaga';
import { resourceCategoriesSagas } from '../pages/Categories/resourceCategoriesSaga';
import { subscriptionSagas } from './slices/subscriptionSaga';
import { playlistAnalyticsSagas } from './slices/playlistAnalyticsSaga';
import { checkInAnalyticsSagas } from './slices/checkInAnalyticsSaga';
import { journalAnalyticsSagas } from './slices/journalAnalyticsSaga';
import { overviewCountsSagas } from './slices/overviewCountsSaga';
import { rolesSagas } from '../pages/Roles/rolesSaga';
import { permissionsSagas } from '../pages/Permissions/permissionsSaga';

export function* rootSaga() {
  yield spawn(authSagas);
  yield spawn(modulesSagas);
  yield spawn(programsSagas);
  yield spawn(resourcesSagas);
  yield spawn(microPracticesSagas);
  yield spawn(playlistsSagas);
  yield spawn(usersSagas);
  yield spawn(settingsSagas);
  yield spawn(programCategoriesSagas);
  yield spawn(resourceCategoriesSagas);
  yield spawn(subscriptionSagas);
  yield spawn(playlistAnalyticsSagas);
  yield spawn(checkInAnalyticsSagas);
  yield spawn(journalAnalyticsSagas);
  yield spawn(overviewCountsSagas);
  yield spawn(rolesSagas);
  yield spawn(permissionsSagas);
}

